module.exports = __webpack_public_path__ + "img/m14.89ddc803.jpg";